import { makeStyles, createStyles } from '@material-ui/styles';
import themes from 'styles/themes';
export const useStyles = makeStyles(() =>
    createStyles({
        wrapper: {
            width: '100%',
            position: 'relative',
        },
        main: {
            background: themes.palette.common.white,

            padding: '20px 24px',
        },
        // header: {
        //     "@media (max-width: 1024px)": {
        //         position: 'fixed',
        //     },
        //     textAlign: "center",
        //     padding: "10px 24px",
        //     position: 'absolute',
        //     display: 'flex',
        //     zIndex: 100,
        //     left: 0,
        //     right: 0,
        //     backgroundColor: '#1D474F',
        //     top: 0,
        //     width: "100%",
        //     alignItems: 'center',
        // },
        contentPage: {
            paddingTop: '36px',
            height: 'auto',
            overflowY: 'scroll',
            paddingBottom: 20,
            paddingRight: 4,
            scrollbarWidth: 'none',
        },
        errorButton: {
            background: 'transparent',
            borderRadius: '29px ',
            textAlign: 'center',
            width: 'auto',
            padding: '10px 28px',
            height: 'auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: `1px solid ${themes.palette.primary.main}`,
            color: themes.palette.primary.main,
            '&:disabled': {
                opacity: 0.5,
            },
            textTransform: 'capitalize',
        },
    }),
);
